import { createLiveStatusContext } from '../realtime/createLiveStatusContext';

const submitting = createLiveStatusContext({
  key: 'submitting',
  startEvent: 'InvoicesSubmitting',
  endEvent: 'InvoicesSubmitCompleted',
});

export const InvoiceLiveStatusProvider = submitting.Provider;
export const useSubmittingIds = submitting.useIds;
export const useIsInvoiceSubmitting = submitting.useIsActive;
export const useOptimisticSubmitAdd = submitting.useOptimisticAdd;
export const useOptimisticSubmitRemove = submitting.useOptimisticRemove;
